<template>
  <div>
    <VerticalCard
      class="first-card pa-0"
      v-if="recommendations.length > 0"
      :document-data="firstRecommendation()"
      @click.native="markUserJournalAsRead"
      :allow-adding-to-reflection="false"
    />
    <DocumentCardIterator
      v-if="recommendations.length > 1"
      :items="remainingRecommendations()"
      :display-num-documents="false"
      @clicked="onRecommendationClicked"
    >
      <template v-slot:item="{ item }">
        <VerticalCard
          :document-data="item"
          @click.native="markUserJournalAsRead"
          :allow-adding-to-reflection="false"
        />
      </template>
    </DocumentCardIterator>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { types } from '../../store/rootTypes';
import DocumentCardIterator from '../cards/DocumentCardIterator';
import VerticalCard from '../cards/documentCards/VerticalCard';

export default {
  name: 'JournalOrgSection',
  components: {
    VerticalCard,
    DocumentCardIterator,
  },
  props: {
    recommendations: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      markUserJournalAsRead: types.authentication.actions.markUserJournalAsRead,
      recommendationClicked: types.recommendationBasedJournals.actions.recommendationClicked,
    }),
    onRecommendationClicked(documentData) {
      return Promise.all([
        this.markUserJournalAsRead(),
        this.recommendationClicked({ doc: documentData }),
      ]);
    },
    firstRecommendation() {
      if (this.recommendations.length === 0) {
        return undefined;
      }

      console.log('firstRecommendation');
      console.log(this.recommendations[0]);
      return this.recommendations[0];
    },
    remainingRecommendations() {
      if (this.recommendations.length > 1) {
        return this.recommendations.slice(1);
      }
      return undefined;
    },
  },
};
</script>
<style scoped>
.first-card {
  width: 100%;
  min-width: 100%;
}
</style>
